import React from 'react';

import { bool, func, string } from 'prop-types';

import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';

import Button from 'components/Common/Buttons/ButtonV3';
import Flexbox from 'components/Common/Flexbox';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';
import Toggle from 'components/Common/Toggle';
import Tooltip from 'components/Common/Tooltip';

const WalletVisibilitySwitch = ({
  isCredentialWalletPublic,
  updateStudentProfile,
  publicLinkTooltip,
  copyToClipboard,
}) => (
  <>
    <Flexbox alignItems="center" columnGap={0.5}>
      <Toggle
        labelDirection="right"
        label="Set as public"
        value={isCredentialWalletPublic}
        checked={isCredentialWalletPublic}
        onChange={(_, checked) => {
          updateStudentProfile({
            payload: {
              isCredentialWalletPublic: checked,
            },
          });
        }}
      />
      <Tooltip placement="left" title={publicLinkTooltip}>
        <div>
          <FontAwesomeIcon icon={faInfoCircle} color="grayDark" />
        </div>
      </Tooltip>
    </Flexbox>
    <Button
      size="small"
      variant="filled"
      color="blue"
      label="Copy link"
      icon={<FontAwesomeIcon icon={faLink} />}
      onClick={copyToClipboard}
      hasIconLeft
      disabled={!isCredentialWalletPublic}
    />
  </>
);

WalletVisibilitySwitch.propTypes = {
  isCredentialWalletPublic: bool.isRequired,
  updateStudentProfile: func.isRequired,
  publicLinkTooltip: string.isRequired,
  copyToClipboard: func.isRequired,
};

export default WalletVisibilitySwitch;
